export const FacebookCrmTypeDecorator = {
  url() {
    return `signup/fb-crm`;
  },

  query() {
    return {};
  }

};